import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submit(event) {
    const form = this.element.form || this.element.closest('form')
    if (!form) return

  // Construir la query y mantener corchetes
    const formData = new FormData(form)
    const params = new URLSearchParams()
    for (let [key, value] of formData.entries()) {
      params.append(key, value)
    }
    let queryString = params.toString().replace(/%5B/g, '[').replace(/%5D/g, ']')
    let url = form.action + (queryString ? ('?' + queryString) : '')

    if (window.Turbo) {
      window.Turbo.visit(url, { action: 'replace' })
      if (event) event.preventDefault()
    } else {
      form.submit()
    }
  }

  connect() {
    if (this.element.tagName === 'INPUT' && this.element.type === 'text') {
      this.element.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.submit(e);
        }
      });
    }
  }
}
